(() => {
  'use strict';
  const maxLetters = 14;
  const maxChildren = 10;
  const ranges = ['1–4 letters', '5–8 letters', '9–14 letters'];
  const letterCount = value => (value.match(/\p{L}/gu) || []).length;
  const clean = value => value.replace(/[^\p{L}\s'-]/gu, '').replace(/\s{2,}/g, ' ').slice(0, 24);
  const money = cents => new Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(Number(cents) / 100);
  const startingMoney = cents => money(cents).replace(/\.00$/, '');
  const tierIndex = count => count <= 4 ? 0 : count <= 8 ? 1 : 2;
  const variantFor = (select, style, count) => Array.from(select?.options || []).find(option =>
    option.dataset.style === style && option.dataset.range === ranges[tierIndex(count)]
  );
  const rowsOf = form => Array.from(form?.querySelectorAll('[data-child]') || []);
  const nameOf = row => row.querySelector('[data-child-name]');
  const radioOf = row => row.querySelector('.swatches input:checked');
  const updateSwatches = row => row.querySelectorAll('.swatches label').forEach(label =>
    label.classList.toggle('selected', Boolean(label.querySelector('input:checked')))
  );
  const cartRoot = () => window.Shopify?.routes?.root || '/';
  const cartItems = details => details.map(({variant, name, style}, index) => ({
    id: Number(variant.value), quantity: 1,
    properties: {"Child's name": name.trim(), Style: style, _child_number: String(index + 1)}
  }));
  const addToCart = async details => {
    const response = await fetch(`${cartRoot()}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: cartItems(details)})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Could not add the bunting to your bag.');
    if (typeof window.upcartOpenCart === 'function') {
      try {
        if (typeof window.upcartRefreshCart === 'function') await Promise.resolve(window.upcartRefreshCart());
      } catch (error) { console.warn('UpCart refresh failed:', error); }
      try { window.upcartOpenCart(); return true; }
      catch (error) { console.warn('UpCart could not open:', error); }
    }
    window.location.assign(`${cartRoot()}cart`);
    return false;
  };

  const homeForm = document.getElementById('buntiful-product-form');
  const hero = document.getElementById('hero-personaliser');
  const heroInput = document.getElementById('hero-child-name');
  const toast = document.getElementById('buntiful-toast');
  const showHomeNotice = message => {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    window.clearTimeout(showHomeNotice.timer);
    showHomeNotice.timer = window.setTimeout(() => { toast.hidden = true; }, 6000);
  };
  const renderHomePreview = details => {
    const first = details[0];
    if (!first) return;
    if (heroInput) heroInput.value = first.name;
    const heroCount = hero?.querySelector('.buntiful-count');
    if (heroCount) heroCount.textContent = `${first.count}/${maxLetters} letters`;
    const heroPrice = document.querySelector('.buntiful-hero-price');
    if (heroPrice) {
      const startingText = `${heroPrice.dataset.fromLabel} ${startingMoney(heroPrice.dataset.minPrice)} - ${heroPrice.dataset.lengthNote}`;
      const allValid = details.every(item => item.valid);
      heroPrice.textContent = first.count > maxLetters ? `Maximum ${maxLetters} letters`
        : details.length > 1 && allValid ? `${details.map(item => item.name.trim()).join(' + ')} - ${money(details.reduce((sum, item) => sum + Number(item.variant.dataset.price), 0))}`
        : details.length > 1 ? startingText
        : first.valid ? `${first.name.trim()} - ${money(first.variant.dataset.price)}`
        : startingText;
    }
    const names = details.filter(item => item.count > 0 && item.count <= maxLetters).map(item => item.name.trim());
    const heading = document.querySelector('.preview-heading');
    if (heading) heading.textContent = names.length > 1 ? 'Their names, made special.' : names.length ? `${names[0].toUpperCase()}, made special.` : (heading.dataset.defaultHeading || heading.textContent);
    const preview = document.querySelector('[data-bunting-preview]');
    if (preview) {
      preview.replaceChildren();
      (names.length ? names : ['NAME']).forEach(name => {
        const line = document.createElement('span');
        line.className = 'bunting-name-line';
        Array.from(name.toUpperCase()).forEach((letter, index) => {
          const flag = document.createElement('span');
          flag.className = `flag flag-${index % 5}`;
          flag.textContent = letter === ' ' ? '\u00a0' : letter;
          line.appendChild(flag);
        });
        preview.appendChild(line);
      });
      preview.setAttribute('aria-label', `Preview of ${names.length ? names.join(' and ') : 'name'} bunting`);
    }
  };

  function initialiseCarousel(root) {
    if (!root) return null;
    const slides = Array.from(root.querySelectorAll('[data-carousel-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-carousel-thumb]'));
    if (!slides.length) return null;
    let active = 0;
    const go = index => {
      if (!Number.isFinite(index)) return;
      active = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === active);
        slide.setAttribute('aria-hidden', String(i !== active));
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === active);
        thumb.setAttribute('aria-pressed', String(i === active));
      });
    };
    root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => go(active - 1));
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => go(active + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => go(index)));
    const stage = root.querySelector('.product-carousel-stage');
    let touchStart = null;
    stage?.addEventListener('touchstart', event => {
      const point = event.touches[0];
      if (point) touchStart = {x: point.clientX, y: point.clientY};
    }, {passive: true});
    stage?.addEventListener('touchend', event => {
      if (!touchStart) return;
      const point = event.changedTouches[0];
      const dx = point.clientX - touchStart.x;
      const dy = point.clientY - touchStart.y;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) go(active + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive: true});
    go(0);
    return {go};
  }

  function initialisePersonaliser(form, {onUpdate, carousel, notify} = {}) {
    if (!form) return null;
    const list = form.querySelector('[data-child-list]');
    const first = list?.querySelector('[data-child]');
    const select = form.querySelector('select[name="id"]');
    const addButton = form.querySelector('[data-add-child]');
    const submitButton = form.querySelector('.add-button');
    const total = form.querySelector('[data-total-price]');
    const totalLabel = form.querySelector('[data-total-label]');
    if (!first || !select || !addButton || !total) return null;
    let nextId = 0;
    let lastStyle = null;
    let submitting = false;

    const render = () => {
      const rows = rowsOf(form);
      const details = rows.map(row => {
        const input = nameOf(row);
        const name = clean(input.value);
        if (input.value !== name) input.value = name;
        const count = letterCount(name);
        const radio = radioOf(row);
        const style = radio?.value || '';
        const shopifyStyle = radio?.dataset.variantStyle || style;
        const variant = variantFor(select, shopifyStyle, count);
        const valid = count >= 1 && count <= maxLetters && Boolean(variant);
        const counter = row.querySelector('[data-child-count]');
        if (counter) counter.textContent = `${count}/${maxLetters} letters`;
        const error = row.querySelector('[data-child-error]');
        if (error) error.hidden = count <= maxLetters;
        input.setAttribute('aria-invalid', String(count > maxLetters));
        const linePrice = row.querySelector('[data-child-price]');
        if (linePrice) { linePrice.hidden = rows.length < 2 || !valid; if (valid) linePrice.textContent = `${name.trim()} · ${money(variant.dataset.price)} AUD`; }
        updateSwatches(row);
        return {row, input, name, count, style, shopifyStyle, radio, variant, valid};
      });
      const complete = details.every(item => item.valid);
      if (submitButton) submitButton.disabled = submitting || !complete;
      addButton.hidden = !complete || rows.length >= maxChildren;
      if (totalLabel) totalLabel.textContent = rows.length > 1 ? totalLabel.dataset.multiLabel : totalLabel.dataset.singleLabel;
      if (complete) {
        const price = money(details.reduce((sum, item) => sum + Number(item.variant.dataset.price), 0));
        total.textContent = rows.length === 1 ? `${details[0].name.trim()} - ${price}` : `${price} AUD`;
      } else total.textContent = '—';
      if (details[0]?.variant) select.value = details[0].variant.value;
      const styleProperty = form.querySelector('[name="properties[Style]"]');
      if (styleProperty) styleProperty.value = details[0]?.style || '';
      const style = details[0]?.style;
      if (carousel && style && style !== lastStyle) {
        carousel.go(Number(details[0].radio.dataset.imageIndex));
        lastStyle = style;
      }
      onUpdate?.(details);
      return details;
    };
    const renumber = () => rowsOf(form).slice(1).forEach((row, index) => {
      const number = index + 2;
      row.querySelector('[data-child-heading]').textContent = `Child ${number}`;
      row.querySelector('.child-name-label').textContent = `Child ${number}'s name`;
    });
    const addChild = ({name = '', style = ''} = {}, focus = true) => {
      if (rowsOf(form).length >= maxChildren) return null;
      const previousStyle = radioOf(rowsOf(form).at(-1))?.value || '';
      const row = first.cloneNode(true);
      const id = ++nextId;
      row.querySelectorAll('*').forEach(element => Array.from(element.attributes).forEach(attribute => {
        if (attribute.name.startsWith('data-shopify-')) element.removeAttribute(attribute.name);
      }));
      const input = nameOf(row);
      input.id = `${nameOf(first).id}-${id}`;
      input.name = `properties[Child ${id + 1}'s name]`;
      input.value = clean(name);
      row.querySelector('.child-name-label').htmlFor = input.id;
      row.querySelector('[data-child-heading]').hidden = false;
      row.querySelector('[data-remove-child]').hidden = false;
      row.querySelector('[data-child-error]').hidden = true;
      row.querySelector('[data-child-price]').hidden = true;
      const radios = Array.from(row.querySelectorAll('.swatches input'));
      radios.forEach(radio => {
        radio.name = `buntiful_style_${id}`;
        radio.removeAttribute('checked');
        radio.checked = false;
      });
      list.appendChild(row);
      const selected = radios.find(radio => radio.value === (style || previousStyle)) || radios[0];
      if (selected) selected.checked = true;
      renumber();
      render();
      if (focus) { input.focus({preventScroll: true}); row.scrollIntoView({behavior: 'smooth', block: 'nearest'}); }
      return row;
    };
    addButton.addEventListener('click', () => addChild());
    list.addEventListener('input', event => { if (event.target.matches('[data-child-name]')) render(); });
    list.addEventListener('change', event => { if (event.target.matches('.swatches input')) render(); });
    list.addEventListener('click', event => {
      const button = event.target.closest('[data-remove-child]');
      if (!button) return;
      button.closest('[data-child]')?.remove();
      renumber();
      render();
    });
    const handleAdd = async event => {
      event.preventDefault();
      event.stopPropagation();
      if (submitting) return;
      const details = render();
      const invalid = details.find(item => !item.valid);
      if (invalid) {
        notify?.(`Please enter a name of 1–${maxLetters} letters and choose a style for each child.`);
        invalid.input.focus();
        return;
      }
      submitting = true;
      submitButton.disabled = true;
      try {
        const opened = await addToCart(details);
        if (opened) { submitting = false; render(); }
      } catch (error) {
        submitting = false;
        notify?.(error.message || 'Please try again.');
        render();
      }
    };
    form.addEventListener('submit', handleAdd);
    submitButton?.addEventListener('click', handleAdd);
    render();
    return {render, addChild, rows: () => rowsOf(form)};
  }

  if (homeForm) {
    const heading = document.querySelector('.preview-heading');
    if (heading) heading.dataset.defaultHeading = heading.textContent;
  }
  const home = initialisePersonaliser(homeForm, {onUpdate: renderHomePreview, notify: showHomeNotice});
  if (home && hero && heroInput) {
    heroInput.addEventListener('input', () => {
      nameOf(home.rows()[0]).value = clean(heroInput.value);
      home.render();
    });
    hero.addEventListener('submit', event => {
      event.preventDefault();
      const count = letterCount(heroInput.value);
      if (count < 1 || count > maxLetters) {
        heroInput.setCustomValidity(`Please enter a name of 1–${maxLetters} letters.`);
        heroInput.reportValidity();
        heroInput.setCustomValidity('');
        return;
      }
      const details = home.render();
      const incomplete = details.slice(1).find(item => !item.valid);
      if (incomplete) { showHomeNotice('Please finish or remove the additional child before continuing.'); incomplete.input.focus(); return; }
      const url = new URL(hero.action, window.location.origin);
      url.searchParams.set('name', clean(heroInput.value).trim());
      if (details[0]?.shopifyStyle) url.searchParams.set('style', details[0].shopifyStyle);
      details.slice(1).forEach(item => url.searchParams.append('child', JSON.stringify({name: item.name.trim(), style: item.shopifyStyle})));
      window.location.assign(url.toString());
    });
  }
  document.querySelectorAll('[data-select-style]').forEach(card => card.addEventListener('click', () => {
    const target = card.dataset.productUrl;
    if (!target) return;
    const url = new URL(target, window.location.origin);
    url.searchParams.set('style', card.dataset.selectStyle);
    const details = home?.render() || [];
    const incomplete = details.slice(1).find(item => !item.valid);
    if (incomplete) { showHomeNotice('Please finish or remove the additional child before continuing.'); incomplete.input.focus(); return; }
    if (details[0]?.valid) url.searchParams.set('name', details[0].name.trim());
    details.slice(1).forEach(item => url.searchParams.append('child', JSON.stringify({name: item.name.trim(), style: item.shopifyStyle})));
    window.location.assign(url.toString());
  }));

  const detailForm = document.getElementById('buntiful-detail-form');
  if (detailForm) {
    const params = new URLSearchParams(window.location.search);
    const first = detailForm.querySelector('[data-child]');
    const incomingName = clean(params.get('name') || '');
    if (letterCount(incomingName) <= maxLetters) nameOf(first).value = incomingName;
    const incomingStyle = params.get('style');
    const matchingStyle = Array.from(first.querySelectorAll('.swatches input')).find(radio => radio.value.toLowerCase() === incomingStyle?.toLowerCase());
    if (matchingStyle) matchingStyle.checked = true;
    const feedback = detailForm.querySelector('.product-feedback');
    const detail = initialisePersonaliser(detailForm, {
      carousel: initialiseCarousel(document.querySelector('[data-product-carousel]')),
      notify: message => { if (feedback) { feedback.textContent = message; feedback.hidden = false; } }
    });
    params.getAll('child').slice(0, maxChildren - 1).forEach(encoded => {
      try {
        const child = JSON.parse(encoded);
        const name = clean(String(child.name || ''));
        if (letterCount(name) >= 1 && letterCount(name) <= maxLetters) detail?.addChild({name, style: String(child.style || '')}, false);
      } catch { /* Ignore malformed URLs. */ }
    });
    detailForm.addEventListener('input', () => { if (feedback) feedback.hidden = true; });
    detailForm.addEventListener('change', () => { if (feedback) feedback.hidden = true; });
  }

  const cartLink = document.querySelector('.cart-link');
  cartLink?.addEventListener('click', event => {
    if (typeof window.upcartOpenCart !== 'function') return;
    event.preventDefault();
    try { window.upcartOpenCart(); }
    catch (error) { console.warn('UpCart could not open:', error); window.location.assign(cartLink.href); }
  });

  const menuButton = document.querySelector('.mobile-menu-button');
  const nav = document.getElementById('buntiful-nav');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    nav?.classList.toggle('is-open', open);
  });
  nav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    nav.classList.remove('is-open');
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Open navigation');
  }));

  const initialiseHeroMedia = media => {
    if (!media || media.dataset.videoReady) return;
    media.dataset.videoReady = 'true';
    const desktop = media.querySelector('.hero-video--desktop');
    const mobile = media.querySelector('.hero-video--mobile');
    if (!desktop && !mobile) return;
    const button = media.querySelector('[data-hero-video-toggle]');
    const smallScreen = window.matchMedia?.('(max-width: 760px)');
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    let visible = true;
    let pausedByUser = false;
    const activeVideo = () => smallScreen?.matches && media.classList.contains('hero-media--mobile-override') ? mobile : desktop;
    const setButton = paused => {
      if (!button) return;
      button.hidden = false;
      button.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} hero video`);
      button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    };
    const sync = () => {
      const current = activeVideo();
      [desktop, mobile].forEach(video => {
        if (!video || video === current) return;
        video.pause();
        video.classList.remove('is-playing');
      });
      if (!current) { if (button) button.hidden = true; return; }
      if (!visible || document.hidden || pausedByUser || reducedMotion?.matches) {
        current.pause();
        if (!pausedByUser) current.classList.remove('is-playing');
        setButton(true);
        return;
      }
      current.muted = true;
      current.playsInline = true;
      current.preload = 'metadata';
      setButton(false);
      const attempt = current.play();
      if (attempt?.catch) attempt.catch(() => {
        current.classList.remove('is-playing');
        pausedByUser = true;
        setButton(true);
      });
    };
    [desktop, mobile].forEach(video => {
      if (!video) return;
      video.addEventListener('playing', () => { video.classList.add('is-playing'); setButton(false); });
      video.addEventListener('error', () => { video.classList.remove('is-playing'); setButton(true); });
    });
    button?.addEventListener('click', () => {
      const current = activeVideo();
      if (!current) return;
      pausedByUser = !current.paused;
      if (pausedByUser) { current.pause(); setButton(true); }
      else {
        current.muted = true;
        current.playsInline = true;
        current.preload = 'metadata';
        const attempt = current.play();
        if (attempt?.catch) attempt.catch(() => { current.classList.remove('is-playing'); setButton(true); });
      }
    });
    smallScreen?.addEventListener?.('change', sync);
    reducedMotion?.addEventListener?.('change', sync);
    document.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold: 0.05}).observe(media);
    }
    sync();
  };
  document.querySelectorAll('[data-hero-media]').forEach(initialiseHeroMedia);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hero-media]').forEach(initialiseHeroMedia));
})();
